import dynamic from 'next/dynamic';
import { ClickToPayProps } from './ClickToPay.types';

export const ClickToPay = dynamic<ClickToPayProps>(() => import('./ClickToPay'));
